var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./historico-whatsapp.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-13cc0fe6\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./historico-whatsapp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/web/consulta/liberacao/_includes/historico-whatsapp.vue
// module id = 660
// module chunks = 45